import dateTime from 'system/libs/dateTime';
import { UrlHelper } from 'utilities/UrlHelper/UrlHelper';

import { BoundCurrentUserSelectors } from 'reactApp/modules/CurrentUserModule';

define((require, exports, module) => {
    'use strict';

    const RPCModel = require('RPCModel');
    const dev = false;
    const cardTypes = require('system/libs/creditCardTypes').creditCardTypes;

    const CreditCard = RPCModel.extend({
        className: 'MCS.Billing.CreditCard',

        idAttr: 'bind_id',

        findUrl: 'projects/:pid/billing/card/bind',
        removeUrl: 'projects/:pid/billing/card/bind?bind_id=:id',
        bindingGateUrl: 'projects/:pid/billing/card/bind',
        payUrl: 'projects/:pid/billing/card/bind/pay',

        defaults: {
            merchant_user_id: '',
            pay_method: void 0,
            payer_id: void 0,
            exp_date: '00/00',
            added: void 0,
            bind_id: void 0,
            description: '',
        },

        parse(body) {
            return body;
        },

        prepareSendData(method, attrs) {
            if (dev) {
                attrs.dev = 1;
            }

            if (method === 'remove') {
                return {};
            }

            return attrs;
        },

        pay(amount, description) {
            amount = (amount * 1).toFixed(2);

            return this.queue((model) => {
                return model.request
                    .post(CreditCard.url('pay'), {
                        amount,
                        bind_id: model.id,
                        description: description || '',
                    })
                    .then((res) => {
                        return res.body;
                    });
            });
        },

        getType() {
            return cardTypes.getCardInfoByNumber(this._getNumber());
        },

        _getNumber() {
            return this.get('description');
        },

        getMaskedNumber() {
            let number = this._getNumber();

            number = number.replace(/^(.+)(\d{4})$/i, (a, b, c) => {
                return c;
            });

            return number;
        },

        getExpirationDate() {
            let date = this.get('exp_date');
            let exp_date;

            if (date) {
                exp_date = new Date();
                date = date.split(date.indexOf('.') !== -1 ? '.' : '/');

                exp_date.setYear(date[1]);
                exp_date.setMonth(date[0] - 1);
            }

            return exp_date;
        },

        getExpirationDateString() {
            const expDate = this.getExpirationDate();

            return expDate ? dateTime.format(expDate, 'MM/yy') : '';
        },

        isExpired() {
            const date = this.getExpirationDate();
            return date && date.getTime() <= new Date().getTime();
        },

        getData() {
            return Object.assign({}, this.toJSON(), {
                number: this.getMaskedNumber(),
                type: this.getType().type,
                expired: this.isExpired(),
                expirationDate: this.getExpirationDateString(),
            });
        },
    });

    Object.assign(CreditCard, {
        getCard() {
            return CreditCard.find({});
        },

        getBindingGateURL(user) {
            const attrs = {
                description:
                    'Для\u00A0проверки c\u00A0вашей карты будет списан 1\u00A0рубль и\u00A0зачислен на\u00A0ваш\u00A0счет в\u00A0Mail.Ru Cloud Solutions',
                merchant_user_id: user,
            };

            if (dev) {
                attrs.dev = 1;
            }

            return CreditCard.fn.request
                .post(CreditCard.url('bindingGate'), attrs)
                .then((res) => {
                    return res.body.url;
                });
        },
    });

    CreditCard.url = function(name, params) {
        const url = this.fn[name + 'Url'] || this.fn.url;

        const pid = BoundCurrentUserSelectors.getPid();

        return UrlHelper.moveParamsToUrlWithSideEffect({
            url,
            params: { pid, ...params },
        });
    };

    module.exports = CreditCard;
});
